/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  Department,
  DepartmentBrief,
  DepartmentFull,
  DepartmentInfo,
  DepartmentTreeBrief,
  DepartmentUpdate,
} from 'SharedDir/declarations/departments';
import {
  ADMINISTRATION_DEPARTMENTS,
  BASE_DEPARTMENT_URL,
} from 'SharedDir/backend/endpoints/administration-departments';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';
import { http } from 'SharedDir/backend/axios/http';

export default class DepartmentApiClass extends SimpleApi<Department, Department> {
  constructor() {
    super(BASE_DEPARTMENT_URL);
  }

  async getDepartments(
    params: PaginationParams<{ name?: string | null }>
  ): Promise<Paginated<Department, any>> {
    const responseData: Paginated<Department, any> = await http({
      ...ADMINISTRATION_DEPARTMENTS.LIST,
      params,
    })
      .then((r): Paginated<Department, any> => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async createDepartment(data: DepartmentUpdate): Promise<DepartmentFull> {
    const responseData: DepartmentFull = await http({
      ...ADMINISTRATION_DEPARTMENTS.CREATE,
      data,
    })
      .then((r): DepartmentFull => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async getDepartmentsBrief(
    params: PaginationParams<any>
  ): Promise<Paginated<DepartmentBrief, any>> {
    const responseData: Paginated<DepartmentBrief, any> = await http({
      ...ADMINISTRATION_DEPARTMENTS.LIST_BRIEF,
      params,
    })
      .then((r): Paginated<DepartmentBrief, any> => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async getDepartmentsBriefTree(
    query: string | null = null
  ): Promise<Paginated<DepartmentTreeBrief, any>> {
    const responseData: Paginated<DepartmentTreeBrief, any> = await http({
      ...ADMINISTRATION_DEPARTMENTS.LIST_BRIEF_TREE,
      params: { query },
    })
      .then((r): Paginated<DepartmentTreeBrief, any> => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async getDepartment(id: number): Promise<DepartmentFull> {
    const responseData: DepartmentFull = await http({
      ...ADMINISTRATION_DEPARTMENTS.GET(id),
    })
      .then((r): DepartmentFull => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async updateDepartment(id: number, data: DepartmentUpdate): Promise<DepartmentFull> {
    const responseData: DepartmentFull = await http({
      ...ADMINISTRATION_DEPARTMENTS.UPDATE(id),
      data,
    })
      .then((r): DepartmentFull => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async deleteDepartment(id: number): Promise<DepartmentFull> {
    const responseData: DepartmentFull = await http({
      ...ADMINISTRATION_DEPARTMENTS.DELETE(id),
    })
      .then((r): DepartmentFull => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  async getDepartmentInfo(id: number): Promise<DepartmentInfo> {
    const responseData: DepartmentInfo = await http({
      ...ADMINISTRATION_DEPARTMENTS.INFO(id),
    })
      .then((r): DepartmentInfo => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }
}
